// Per-call OpenAI usage report API (Backend/controllers/usageReportController.js).
//   scope "merchant" -> /billing/usage   (Billing section, current store only)
//   scope "admin"    -> /admin/usage     (Admin > Usage, all customers)
import API_BASE from "../config/api";
import { auth } from "../config/config-firebase";
import { isAdminMerchantMode } from "./adminMerchantMode";

// Same token rules as components/workflow/imageCreationService.js.
const getMerchantToken = async () => {
  if (isAdminMerchantMode()) return localStorage.getItem("admin_token") || "";
  if (typeof auth.authStateReady === "function") await auth.authStateReady();
  if (auth.currentUser) return auth.currentUser.getIdToken();
  return localStorage.getItem("auth_token") || "";
};

const getToken = (scope) => (scope === "admin" ? Promise.resolve(localStorage.getItem("admin_token") || "") : getMerchantToken());

const buildUrl = (scope, suffix, { from, to, customerId, page, pageSize }) => {
  const params = new URLSearchParams({ tzOffset: String(new Date().getTimezoneOffset()) });
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  if (page) params.set("page", String(page));
  if (pageSize) params.set("pageSize", String(pageSize));
  if (scope === "merchant") {
    params.set("customerId", localStorage.getItem("customer_id") || "");
  } else if (customerId) {
    params.set("customerId", customerId);
  }
  return `${API_BASE}/${scope === "admin" ? "admin" : "billing"}/usage${suffix}?${params}`;
};

const authedFetch = async (scope, url) => {
  const token = await getToken(scope);
  let res;
  try {
    res = await fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  } catch {
    throw new Error("Network error. Check your connection and try again.");
  }
  if (!res.ok) {
    let msg = "Couldn't load the usage report. Please try again.";
    try {
      msg = (await res.json()).message || msg;
    } catch {
      /* non-JSON error body */
    }
    throw new Error(msg);
  }
  return res;
};

export async function fetchUsageReport(scope, filters) {
  const res = await authedFetch(scope, buildUrl(scope, "", filters));
  return (await res.json()).data;
}

// Downloads the CSV for the filters (blob fetch so the auth header is sent).
export async function downloadUsageCsv(scope, filters) {
  const res = await authedFetch(scope, buildUrl(scope, "/export", filters));
  const blob = await res.blob();
  const name = `usage-report_${filters.from || "start"}_to_${filters.to || "now"}.csv`;
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}
